/**
 * API configuration constants
 * @constant
 */
export const API_CONFIG = {
  /** Backend API URL - reads from REACT_APP_API_URL environment variable */
  MATERIOM_AI_BACKEND_URL:
    process.env.REACT_APP_MATERIOM_AI_BACKEND_URL ||
    "https://dev-materiom-ai-651763794163.europe-west1.run.app",
  COMMONS_BACKEND_URL:
    process.env.REACT_APP_COMMONS_BACKEND_URL ||
    "https://dev-commons-651763794163.europe-west1.run.app",
} as const;

// Sidebar Configuration
export const SIDEBAR_CONFIG = {
  MIN_WIDTH: 300,
  MAX_WIDTH: 800,
  DEFAULT_WIDTH: 600,
} as const;

// Documentation URL
export const DOCUMENTATION_URL =
  "https://docs.google.com/document/d/e/2PACX-1vQl2pTlApRRMEQk3FnouLyyZ3zKrgKlWU0KJHP7sRY9PMmVacYqW7MeaUckIANlIXnBpsx1_q9yhO04/pub";

// Staging Environments
export const STAGING_ENVIRONMENTS = {
  DEV: "dev",
  STAGING: "staging",
  PROD: "prod",
} as const;

// PostHog Configuration
export const POST_HOG_OPTIONS = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
} as const;

export const MATERIALS_DATABASE_URL =
  process.env.REACT_APP_MATERIALS_DATABASE_URL ||
  "https://dev-commons-search-ui-651763794163.europe-west1.run.app";

// Re-export routes for easier importing
export { ROUTES, DEFAULT_REDIRECT_PATH } from "./routes";

// TODO: Remove these two lines below - they seem to have been introduced erroneously
// as the frontend app is not served with VITE and these appear to be unused
export const privacyNoticeUrl = process.env.VITE_PRIVACY_NOTICE_URL;
export const termsAndConditionsUrl = process.env.VITE_TERMS_AND_CONDITIONS_URL;

// Constants for JWT token key
export const AUTH_TOKEN_KEY = "jwt_token";

// Constants for footer URLs
export const FOOTER_URLS = {
  TERMS_AND_CONDITIONS: "https://materiom.org/terms-and-conditions",
  PRIVACY_POLICY: "https://materiom.org/privacy-policy",
} as const;

// Feature Request Banner Configuration
export const FEATURE_REQUEST_BANNER = {
  BANNER_STATE_KEY: "featureRequestBannerState",
  BANNER_EXPIRY_HOURS: 3 * 24,
  SHUFFLE_FEATURES: true,
} as const;
